import React from "react";
import { useNavigate } from "react-router-dom";
import bgImg from "../../Assets/homeBgImg.jpg";
import { MdOutlineQrCodeScanner } from "react-icons/md";

const Home = () => {
  const navigate = useNavigate();

  const handleStartScanner = () => {
    navigate("/scanner");
  };

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        backgroundImage: `url(${bgImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      <div
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          padding: "2rem",
          borderRadius: "15px",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
          maxWidth: "80%",
          margin: "0 auto",
        }}
      >
        <h1 style={{ color: "#143785", marginBottom: "1rem" }}>Welcome to VMS Scanner</h1>
        <p style={{ color: "#666", marginBottom: "2rem" }}>
          Scan QR codes quickly and efficiently
        </p>
      </div>

      <div
        onClick={handleStartScanner}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "12px",
          padding: "15px 40px",
          fontSize: "18px",
          backgroundColor: "#143785",
          color: "white",
          borderRadius: "30px",
          cursor: "pointer",
          textAlign: "center",
          position: "fixed",
          bottom: "80px",
          left: "50%",
          transform: "translateX(-50%)",
          whiteSpace: "nowrap",
          boxShadow: "0 4px 15px rgba(20, 55, 133, 0.3)",
          transition: "all 0.3s ease",
          border: "none",
          ":hover": {
            backgroundColor: "#1a4ba3",
            transform: "translateX(-50%) translateY(-2px)",
            boxShadow: "0 6px 20px rgba(20, 55, 133, 0.4)",
          },
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = "#1a4ba3";
          e.currentTarget.style.transform = "translateX(-50%) translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 6px 20px rgba(20, 55, 133, 0.4)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = "#143785";
          e.currentTarget.style.transform = "translateX(-50%)";
          e.currentTarget.style.boxShadow = "0 4px 15px rgba(20, 55, 133, 0.3)";
        }}
      >
        <MdOutlineQrCodeScanner style={{ fontSize: "28px" }} />
        <span>Start Scanning</span>
      </div>
    </div>
  );
};

export default Home;
